import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { CHANNEL_MANAGER_NIGHTS } from '../../../../brands/default/content/components/deal';
import { MAX_NIGHTS_DEFAULT } from '../../../../helpers/booking';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';

const ChannelManagerNights = ({ initialNights, maxNights, onNightChange }) => {
  const [nights, setNights] = useState(null);
  const [selectedValue, setSelectedValue] = useState(1);
  const { cmChooseNights } = CHANNEL_MANAGER_NIGHTS;
  const onChange = (event) => {
    setSelectedValue(event.target.value);
    onNightChange(event.target.value);
  };

  useEffect(() => {
    const defaultNights = [];
    for (let index = 1; index <= MAX_NIGHTS_DEFAULT; index++) {
      defaultNights.push(index);
    }
    setNights(defaultNights);
  }, []);

  useEffect(() => {
    setNights(maxNights);
  }, []);

  useEffect(() => {
    if (nights && nights.length > 0) {
      if (initialNights && nights?.length > initialNights) {
        setSelectedValue(initialNights);
        onNightChange(initialNights);
      } else {
        setSelectedValue(nights[0]);
        onNightChange(nights[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nights, initialNights]);

  return (
    nights && (
      <>
        <CustomNativeSelect
          ariaLabel={cmChooseNights}
          /* eslint-disable-next-line react/forbid-component-props */
          className="full-width margin"
          id="num-nights"
          isLarge
          onChange={onChange}
          value={selectedValue}
        >
          {nights.map((night) => {
            return (
              <option key={night} value={night}>
                {night}
              </option>
            );
          })}
        </CustomNativeSelect>
      </>
    )
  );
};

ChannelManagerNights.propTypes = {
  initialNights: PropTypes.number,
  maxNights: PropTypes.array,
  onNightChange: PropTypes.func.isRequired,
};

export default ChannelManagerNights;
